import { render, staticRenderFns } from "./AI-report.vue?vue&type=template&id=5e152174"
import script from "./AI-report.vue?vue&type=script&lang=js"
export * from "./AI-report.vue?vue&type=script&lang=js"
import style0 from "./AI-report.vue?vue&type=style&index=0&id=5e152174&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports